import React, { useState } from "react";
import "./GenerateReportPopup.scss";

import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { PO_TYPE } from "../../pages/PurchaseOrderStatus/ClientPurchaseOrder.data";
import { toast } from "react-toastify";
import { toastOptions } from "../../utils/toast";

interface GenerateReportPopupProps {
  handleClose: () => void;
  handleGenerateReport: (start: string, end: string) => void;
}

const GenerateReportPopup: React.FC<GenerateReportPopupProps> = ({
  handleClose,
  handleGenerateReport,
}) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleSubmit = () => {
    console.log("submit function");
    if (startDate.length == 0 || endDate.length === 0) {
      toast.error("Please Fill the Details", toastOptions);
      return;
    }
    handleGenerateReport(startDate, endDate);
  };
  return (
    <div className="generate-report-popup-main-container">
      <div className="flex-row gap-15 align-items-center justify-content-space-between p-16">
        <p className="heading xetgo-font-button bold">Report</p>
        <img
          className="cursor-pointer"
          height={16}
          width={16}
          onClick={() => handleClose()}
          src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240209103001-x.svg"
        />
      </div>
      <div className="generate-report-middle-container flex-column gap-22 p-16">
        <div className="flex-row gap-12">
          <div className="flex-column gap-6 flex-1">
            <p style={{ color: "#484848" }} className="xetgo-font-tag">
              From
            </p>
            <div className="custom-question-date-value xetgo-font-tag">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className={`generate-report-date-input px-12 py-8 xetgo-font-tag full-width border-box disable-cursor`}
                  value={dayjs("".split("-").reverse().join("-"))}
                  format={"DD-MM-YYYY"}
                  views={["year", "month", "day"]}
                  onChange={(event) =>
                    setStartDate(event?.toDate().toISOString() || "")
                  }
                />
              </LocalizationProvider>
            </div>
          </div>
          <div className="flex-column gap-6 flex-1">
            <p style={{ color: "#484848" }} className="xetgo-font-tag">
              To
            </p>
            <div className="custom-question-date-value xetgo-font-tag">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className={`generate-report-date-input px-12 py-8 xetgo-font-tag full-width border-box disable-cursor`}
                  value={dayjs("".split("-").reverse().join("-"))}
                  format={"DD-MM-YYYY"}
                  views={["year", "month", "day"]}
                  onChange={(event) =>
                    setEndDate(event?.toDate().toISOString() || "")
                  }
                />
              </LocalizationProvider>
            </div>
          </div>
        </div>
      </div>
      <div className="generate-btn-container flex-row align-items-center justify-content-end py-16 px-16">
        <div
          onClick={handleSubmit}
          className="generate-btn cursor-pointer px-16 py-8 xetgo-font-tag"
        >
          Generate Report
        </div>
      </div>
    </div>
  );
};

export default GenerateReportPopup;
